import React, { Component } from 'react';
import { GradientPage } from '../../components';
import { multiLanguage } from "../../hoc";

const bgImg = 'https://lagunaproperty.com/images/03-sanctuary-club_63.jpg';
const contentData = {
  en: '<h2>The services team</h2><p>A centralised multilingual team at Sanctuary Club handles all owner enquiries, accommodation reservations and requests.<br/><br/>In addition to assisting members, the team of well-trained staff maintains owner preferences to ensure a perfectly smooth and customized booking service and a memorable stay.</p>',
  cn: '',
  ru: ''
}

@multiLanguage()
export default class Service extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className="section10-service">
        <GradientPage image={bgImg}>
          <div className="text" dangerouslySetInnerHTML={{ __html: t(contentData) }} />
        </GradientPage>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/SanctuaryClub/Service.js